export type ChartData = {
  data: number[];
  labels: string[];
  legend: string;
  type: string;
  chartHeight: number;
  visible: boolean;
  color?: string;
};
